import React from 'react';
import { FormattedMessage } from 'translations';
import ModalWrapper from 'app/components/base/ModalWrapper';
import Icon from 'app/components/base/Icon';
import { Button } from 'mz-ui-kit/core/Button';
import style from './style.css';

// Constants
const messages = {
  message: { id: 'CONFIRMATION_PAGE.PAY_NOW_CONFIRM_MESSAGE' },
  confirm: { id: 'CONFIRM' },
  cancel: { id: 'CANCEL' },
};

/**
 * "Are you sure you want to pay now?" confirmation dialog shown before
 * actually charging a Buy Now, Pay Later reservation, so an accidental
 * click on Pay Now doesn't charge the customer right away. No title —
 * just the message, a close "x", and Cancel/Confirm actions.
 * @param {Boolean} processing - true while the charge request is in flight
 * @param {Function} onConfirm
 * @param {Function} onCancel
 */
const PayNowConfirmModal = ({ processing, onConfirm, onCancel }) => (
  <ModalWrapper>
    <div className={style.body}>
      <button
        type="button"
        className={style.close}
        onClick={processing ? undefined : onCancel}
        disabled={processing}
        aria-label="Close"
      >
        <Icon name="close" />
      </button>
      <p className={style.message}>
        <FormattedMessage {...messages.message} />
      </p>
      <div className={style.actions}>
        <Button onClick={onCancel} appearance="flat" disabled={processing}>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button onClick={onConfirm} loading={processing} disabled={processing}>
          <FormattedMessage {...messages.confirm} />
        </Button>
      </div>
    </div>
  </ModalWrapper>
);

export default PayNowConfirmModal;
